<template>
  <div>
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>Perguntas Frequentes</h4>
                <div class="row">
                  <div class="col-md-12 col-sm-12">
                    <p>
                      <strong>
                        1. Por que os agentes públicos devem prestar declaração
                        de seus bens e valores?
                      </strong>
                    </p>
                    <p>
                      Por exigência da Lei Federal nº 8.429/1992, regulamentada
                      pelo Decreto Municipal n.º 7.517/2016.
                    </p>
                    <br />
                    <p>
                      <strong>
                        2. Quem deve declarar?
                      </strong>
                    </p>
                    <p>
                      Todos os agentes públicos municipais, ou seja, os que
                      exerçam, ainda que transitoriamente ou sem remuneração,
                      por eleição, nomeação, designação, contratação ou qualquer
                      outra forma de investidura ou vínculo, mandato, cargo,
                      emprego ou função na Administração Pública Direta ou
                      Indireta.
                    </p>
                    <br />
                    <p>
                      <strong>
                        3. Quem está dispensado de prestar a declaração?
                      </strong>
                    </p>
                    <p>
                      Estão dispensados do preenchimento da declaração
                      servidores aposentados, pensionistas, estagiários, agentes
                      públicos cedidos a outros órgãos durante o período de
                      cessão<strong> SEM VENCIMENTOS</strong> e os funcionários
                      contratados por empresas prestadoras de serviços
                      (terceirizados).
                    </p>
                    <br />
                    <p>
                      <strong>
                        4. Prestei a declaração no ano passado. Preciso declarar
                        novamente neste ano?
                      </strong>
                    </p>
                    <p>
                      Sim. A entrega deve ser renovada anualmente, com dados
                      atualizados.
                    </p>
                    <br />
                    <p>
                      <strong>
                        5. Quando devo declarar?
                      </strong>
                    </p>
                    <p>
                      O agente público deverá apresentar a declaração através da
                      CENTRAL DO SERVIDOR nas seguintes situações:
                      <br />&nbsp;&nbsp;• anualmente (atualização) 30 dias após
                      data limite para a entrega da Declaração de Imposto de
                      Renda, fixado pela Receita Federal; <br />&nbsp;&nbsp;• no
                      ato de posse ou admissão em cargo, função ou emprego; • na
                      data em que o agente público deixar o vínculo;
                    </p>
                    <br />
                    <p>
                      <strong>
                        6. Onde posso acessar o sistema para preencher a
                        declaração?
                      </strong>
                    </p>
                    <p>
                      O acesso ao CENTRAL DO SERVIDOR está disponível, via
                      internet, no seguinte endereço:
                      https://egov.santos.sp.gov.br/centraldoservidor
                    </p>
                    <br />
                    <p>
                      <strong>
                        7. Quais bens e valores devo incluir na minha
                        declaração?
                      </strong>
                    </p>
                    <p>
                      A declaração compreenderá imóveis, móveis, semoventes
                      (rebanhos), dinheiro, títulos, ações, investimentos
                      financeiros, participações societárias e qualquer outra
                      espécie de bens e valores patrimoniais localizados no país
                      ou no exterior, e abrangerá, se existentes, os bens e
                      valores patrimoniais do cônjuge ou companheiro, dos filhos
                      e/ou de outras pessoas que sejam parceiros econômicos do
                      declarante.
                    </p>
                    <br />
                    <p>
                      <strong>
                        8. Os valores da minha declaração devem estar
                        atualizados até qual data?
                      </strong>
                    </p>
                    <p>
                      Na atualização anual, a declaração deve conter os valores
                      atualizados até o dia 31 de dezembro do ano anterior, nos
                      mesmos moldes da declaração de ajuste do Imposto de Renda
                      Pessoa Física.
                    </p>
                    <br />
                    <p>
                      <strong>
                        9. Como defino o valor do bem a ser declarado? Pelo
                        valor de aquisição ou pelo valor atual de mercado?
                      </strong>
                    </p>
                    <p>
                      Os bens devem ser declarados sempre pelo seu valor de
                      aquisição, seguindo a regra da Receita Federal. Portanto,
                      os bens não devem ser valorizados ou depreciados em razão
                      da variação do seu valor de mercado no decorrer do ano.
                    </p>
                    <br />
                    <p>
                      <strong>
                        10. De que forma declaro bens adquiridos por meio de
                        financiamento?
                      </strong>
                    </p>
                    <p>
                      Os bens adquiridos por meio de financiamento podem ser
                      declarados da seguinte maneira: <br />&nbsp;&nbsp;•
                      Somando-se os valores pagos de entrada e das parcelas de
                      financiamento quitadas até o dia 31 de dezembro de cada
                      ano e informando na descrição a composição do cálculo.
                    </p>
                    <br />
                    <p>
                      <strong>
                        11. Devo incluir na minha declaração meus ativos
                        bancários (saldo em conta corrente, conta poupança,
                        aplicações financeiras, entre outros)?
                      </strong>
                    </p>
                    <p>
                      Sim. Recomenda-se a utilização do informe de rendimentos
                      fornecido pelas instituições financeiras para fins de
                      declaração de ajuste do Imposto de Renda Pessoa Física.
                    </p>
                    <br />
                    <p>
                      <strong>
                        12. Em que situações devo incluir os bens do meu
                        cônjuge?
                      </strong>
                    </p>
                    <p>
                      A declaração deverá abranger os bens comuns do casal, isto
                      é, os bens adquiridos pelo cônjuge, ainda que apenas em
                      seu nome, a título oneroso e durante o casamento, quando o
                      regime matrimonial for a comunhão total ou parcial de bens
                      ou, ainda, nos casos de união estável. Não são
                      consideradas aquisições a título oneroso, por exemplo, as
                      provenientes de herança ou doação recebidas pelo cônjuge.
                      Não é obrigatória a declaração de bens do cônjuge quando o
                      regime matrimonial for a separação de bens ou a
                      comunicação final de aquestos, exceto se o cônjuge for
                      dependente econômico do declarante.
                    </p>
                    <br />
                    <p>
                      <strong>
                        13. De que forma declaro os bens e valores do meu
                        cônjuge ou companheiro (a)?
                      </strong>
                    </p>
                    <p>
                      Informe essa titularidade na descrição do bem
                      correspondente. O valor atribuído ao bem deve ser
                      integral, e não de 50% do total.
                    </p>
                    <br />
                    <p>
                      <strong>
                        14. Meu cônjuge ou companheiro (a) também é agente
                        público municipal e terá que a fazer a declaração de
                        bens. Neste caso, as regras para declaração de bens do
                        cônjuge permanecem as mesmas?
                      </strong>
                    </p>
                    <p>
                      Sim. Ambas as declarações são independentes entre si.
                    </p>
                    <br />
                    <p>
                      <strong>
                        15. Tenho plano de previdência privada. Como declarar?
                      </strong>
                    </p>
                    <p>
                      Caso o plano seja um VGBL, os saldos devem ser declarados
                      normalmente. Os saldos dos planos do tipo PGBL não
                      precisam ser declarados. Facultativamente, o agente
                      público pode informar os pagamentos efetuados nesse plano
                      (vide questão 16).
                    </p>
                    <br />
                    <p>
                      <strong>
                        16. Além dos bens e valores, quais outros itens posso
                        incluir na minha declaração?
                      </strong>
                    </p>
                    <p>
                      Caso queira, o agente público pode declarar os rendimentos
                      recebidos, os pagamentos e as doações efetuados e as suas
                      dívidas. Estes itens podem se referir ao próprio agente
                      público, ao seu cônjuge ou aos seus dependentes.
                    </p>
                    <br />
                    <p>
                      <strong>
                        17. Tenho dois ou mais vínculos. Estou ativo em um deles
                        e aposentado no outro. Devo fazer a declaração de bens e
                        valores?
                      </strong>
                    </p>
                    <p>
                      Sim. A declaração deverá ser prestada normalmente.
                    </p>
                    <br />
                    <p>
                      <strong>
                        18. Estou dispensado da apresentação da declaração anual
                        de ajuste de imposto de renda à Receita Federal. Tenho
                        que apresentar a declaração de bens e valores?
                      </strong>
                    </p>
                    <p>
                      Sim. Neste caso, o agente público pode utilizar
                      normalmente a CENTRAL DO SERVIDOR.
                    </p>
                    <br />
                    <p>
                      <strong>
                        19. Comecei a trabalhar neste ano na Prefeitura e já
                        apresentei declaração de bens e valores na minha posse.
                        Devo entregar a declaração novamente?
                      </strong>
                    </p>
                    <p>
                      Sim, caso a declaração apresentada para fins de posse ou
                      admissão tenha sido feita antes do início do prazo
                      determinado da declaração anual.
                    </p>
                    <br />
                    <p>
                      <strong>
                        20. Como faço para comprovar que entreguei minha
                        declaração?
                      </strong>
                    </p>
                    <p>
                      O sistema registra automaticamente a entrega da sua
                      declaração. O agente público poderá imprimir o protocolo
                      de entrega ou salvar o arquivo correspondente a qualquer
                      tempo, mediante acesso ao sistema.
                    </p>
                    <br />
                    <p>
                      <strong>
                        21. Entreguei a declaração com dados incorretos ou
                        incompletos. Posso retificá-la?
                      </strong>
                    </p>
                    <p>
                      Sim. O sistema agora permite declarações de retificação,
                      mas só será permitida uma retificação por declaração.
                    </p>
                    <br />
                    <p>
                      <strong>
                        22. Quais as consequências de se deixar de prestar a
                        declaração de bens e valores?
                      </strong>
                    </p>
                    <p>
                      O agente que não prestar a declaração de bens e valores
                      dentro dos prazos previstos ficará sujeito à suspensão do
                      pagamento de sua remuneração até o efetivo cumprimento da
                      obrigação, sem prejuízo da aplicação das demais sanções
                      previstas em lei.
                    </p>
                    <br />
                    <p>
                      <strong>
                        23. Quais os navegadores compatíveis com a CENTRAL DO
                        SERVIDOR?
                      </strong>
                    </p>
                    <p>
                      Google Chrome e Mozilla Firefox.
                    </p>
                    <br />
                    <p>
                      <strong>
                        24. Ainda tenho outras dúvidas e não encontrei a
                        resposta nesse questionário. Quem pode me ajudar?
                      </strong>
                    </p>
                    <p>
                      Eventuais dúvidas devem ser encaminhadas para o email
                      declaracaodebens@santos.sp.gov.br
                    </p>
                    <br />
                    <p>
                      <strong>
                        25. Caso eu não possua bens a declarar, como procedo na
                        declaração?
                      </strong>
                    </p>
                    <p>
                      Para uma declaração sem bens, você pode clicar no botão
                      SEM BENS, que se encontra na tela de declaração e no
                      painel lateral, e confirmar quando solicitado. OU basta
                      não informar nenhum bem (item), salvar e confirmar.
                      Automaticamente, o sistema reconhece sua declaração como
                      não possuir bens para declarar.
                    </p>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section role="controller">
      <div class="container footer-controller">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <botao
              estilo="cheio-verde-esq"
              rotulo="Voltar"
              icone="voltar"
              @clicado="anteriorLink()"
            >
            </botao>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import Botao from '@/components/botao';
import moment from 'moment';

export default {
  name: 'ListaEtapas',

  data() {
    return {
      apiErrors: null,
    };
  },

  methods: {
    anteriorLink() {
      this.$router.go(-1);
    },
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    botao: Botao,
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?4975f73d